 import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import * as yup from "yup";


export interface IConsultingAuthorizationsDataTableFilterFormMeta {
  acquirerBank: FormInputMeta,
  issuerBank: FormInputMeta,
  authorizationNumber: FormInputMeta,
  merchantId: FormInputMeta,
  cardNumber: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  // Schema
  schema: any,
}

const ConsultingAuthorizationsDataTableFilterFormMeta = {} as IConsultingAuthorizationsDataTableFilterFormMeta;


ConsultingAuthorizationsDataTableFilterFormMeta.acquirerBank = {
  name: 'acquirerBank',
  type: 'select',
  label: 'Banque Acquereur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingAuthorizationsDataTableFilterFormMeta.issuerBank = {
  name: 'issuerBank',
  type: 'select',
  label: 'Banque Emetteur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingAuthorizationsDataTableFilterFormMeta.authorizationNumber = {
  name: 'authorizationNumber',
  type: 'select',
  label: 'Numero autorisation',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingAuthorizationsDataTableFilterFormMeta.merchantId = {
  name: 'merchantId',
  type: 'select',
  label: 'ID Commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingAuthorizationsDataTableFilterFormMeta.cardNumber = {
  name: "cardNumber",
  type: "date",
  label: "Numero Carte",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
ConsultingAuthorizationsDataTableFilterFormMeta.startDate = {
  name: "startDate",
  type: "date",
  label: "Du",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
ConsultingAuthorizationsDataTableFilterFormMeta.endDate = {
  name: "endDate",
  type: "date",
  label: "Au",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};



ConsultingAuthorizationsDataTableFilterFormMeta.schema = yup.object().shape(getValidationSchema(ConsultingAuthorizationsDataTableFilterFormMeta));

export default ConsultingAuthorizationsDataTableFilterFormMeta;